import { useState } from "react";

export const useMarketsDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleClose = () => setIsOpen(false);

  return {
    anchorEl,
    setAnchorEl,
    isOpen,
    handleToggle,
    handleClose,
  };
};
